// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2g1eL","title":"ClientReferral_title__3B4Fm","itemText":"ClientReferral_itemText__XTlVN"};